@if (viewItems().length) {
  <div class="context-nav">
    @for (item of viewItems(); track item.id) {
      <button
        class="context-nav__item"
        [class.context-nav__item--stacked]="item.isStacked"
        type="button"
        [attr.aria-label]="item.label | translate"
        [attr.aria-expanded]="item.expanded"
        (click)="onTriggerToggle($event, item)"
        (keydown.space)="$event.preventDefault()"
      >
        @if (item.isStacked) {
          <div class="context-nav__meta">
            <ocp-avatar
              [userInitials]="item.triggerAvatarInitial"
              [colorSeed]="item.triggerColorSeed ?? item.colorSeed ?? item.id"
              size="md"
              singleInitial
            />
            <span class="context-nav__meta-label" ocpTruncate>{{
              item.triggerTitle | translate
            }}</span>
          </div>
        }

        <div class="context-nav__description">
          @if (item.showCompactTriggerAvatar) {
            <ocp-avatar
              [userInitials]="item.initial"
              [colorSeed]="item.colorSeed ?? item.id"
              size="md"
              singleInitial
            />
          }
          <span class="context-nav__label" ocpTruncate>{{ item.label | translate }}</span>
          <ocp-themed-icon
            name="chevron-down.svg"
            [size]="item.chevronSize"
            aria-hidden="true"
            class="context-nav__chevron"
          />
        </div>
      </button>
    }
  </div>

  <hlm-popover
    class="absolute"
    [attachTo]="activeTrigger()"
    [state]="overlayState()"
    (stateChanged)="onStateChanged($event)"
  >
    <hlm-popover-content *hlmPopoverPortal>
      @if (activePopoverItem(); as active) {
        <ocp-sidebar-list
          class="context-nav__popover"
          [items]="active.items"
          [title]="active.popoverTitle"
          [createLabel]="active.createLabel"
          [footerActions]="active.popoverFooterActions"
          [variant]="active.popoverVariant"
          [class.context-nav__popover--compact]="active.compactPopover"
          (itemClicked)="onSidebarListItemClick($event)"
          (createClicked)="onCreateClick(active.id)"
          (footerActionClicked)="onFooterActionClick(active.id, $event)"
          [showCreate]="showCreate()"
          [showCreateInHeader]="showCreateInHeader()"
        />
      }
    </hlm-popover-content>
  </hlm-popover>
}
